import Image from 'next/image'
import Link from 'next/link'
import { WhatsAppIcon } from './components/WhatsAppIcon'
import { CalculatorSolarContext } from 'context/CalculatorSolarContext'
import { FC, useContext } from 'react'
import { FormContainer } from '../FormContainer'
import { motion } from 'framer-motion'
import houseImage from '@assets/v2/house-finished.png'
import { HomeButton } from '@components/home/components/home-button'

interface Props {
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'
}

export const Finished: FC<Props> = ({ headingLevel }) => {
  const { handleResetSimulation, leadData } = useContext(CalculatorSolarContext)

  return (
    <FormContainer headingLevel={headingLevel}>
      <div className="flex flex-col items-center h-full font-myriad px-4">
        <Image
          src={houseImage}
          alt=""
          quality={100}
          className="w-[220px] mt-3 xl:mt-0 1.5xl:w-[360px] 1.5xl:-mt-2 1.5xl:-ml-2"
        />

        <div className="flex flex-col justify-between gap-3 w-full mt-auto lg:gap-4 xl:gap-3">
          <motion.p
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0 }}
            className="w-full text-[10px] leading-[12px] text-center tracking-wide font-bold uppercase lg:text-[12px] lg:leading-[19px] xl:text-[10px] xl:leading-[12px] 1.5xl:text-[12px] 1.5xl:leading-[19px]"
            id="render_sucesso"
          >
            <span className="text-orange">SUCESSO!</span> LOGO ENTRAREMOS EM{' '}
            <br />
            CONTATO COM VOCÊ
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            <HomeButton
              variant="outline-primary"
              type="button"
              onClick={handleResetSimulation}
            >
              Refazer a simulação
            </HomeButton>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 1 }}
            className="self-center"
          >
            <Link
              href={`https://api.whatsapp.com/send?phone=11972132657&text=Ol%C3%A1%2C%20sou%20o%20${leadData?.name}%2C%20realizei%20a%20simula%C3%A7%C3%A3o%20de%20n%C3%BAmero%20${leadData?.id}%20no%20site%20e%20estou%20interessado%20em%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20aquisi%C3%A7%C3%A3o%20de%20um%20sistema%20solar%20fotovoltaico.`}
              className="font-myriad text-lg leading-7 font-semibold underline flex gap-2 items-center"
              target="_blank"
              style={{
                fontVariant: 'normal'
              }}
            >
              WhatsApp{' '}
              <div className="w-4 h-4 mb-1">
                <WhatsAppIcon />
              </div>
            </Link>
          </motion.div>
        </div>
      </div>
    </FormContainer>
  )
}
